exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2t26eCmyJWz0-LKAW8ZcYt{font-size:17px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\";cursor:pointer;overflow:hidden;text-overflow:ellipsis}html[dir] ._2t26eCmyJWz0-LKAW8ZcYt{background:transparent;border-width:0}html[dir=ltr] ._2t26eCmyJWz0-LKAW8ZcYt{text-align:left}html[dir=rtl] ._2t26eCmyJWz0-LKAW8ZcYt{text-align:right}", ""]);

// exports
exports.locals = {
	"groupName": "_2t26eCmyJWz0-LKAW8ZcYt"
};